import React, { Component } from "react";
import "../Styles/SvgCommand.css";

class DiscardCommand extends Component {
  state = { canShowForm: false };
  
  render() {
    
    return (
        <svg className= {this.props.actif ? "actif": "disable"} height={this.props.height? this.props.height :"18"} viewBox="0 0 512.007 512.007" onClick={this.props.onClick}>
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
            <path d="M95 5106 c-37 -16 -70 -52 -84 -89 -8 -19 -11 -264 -11 -753 0 -701
              1 -726 20 -763 11 -22 36 -50 57 -62 l38 -24 705 -3 c388 -2 724 0 748 3 57 8
              118 62 132 116 23 85 14 98 -277 390 -146 147 -263 272 -259 278 12 19 171
              128 278 190 404 235 898 341 1356 290 814 -89 1517 -656 1781 -1436 149 -439
              149 -927 0 -1366 -160 -473 -486 -879 -919 -1143 -527 -321 -1185 -393 -1780
              -195 -282 94 -553 256 -779 465 -94 88 -128 106 -203 106 -153 0 -253 -156
              -189 -295 37 -81 293 -301 501 -430 661 -409 1467 -496 2201 -239 130 45 354
              152 479 228 321 196 635 507 844 836 72 113 188 353 235 486 235 662 194 1372
              -115 1993 -133 269 -271 459 -488 677 -227 226 -429 369 -711 505 -490 235
              -1015 303 -1565 204 -410 -73 -821 -257 -1164 -517 l-79 -60 -301 300 c-165
              166 -314 306 -329 312 -38 14 -85 12 -122 -4z"/>
          </g>
        </svg>
    );

    /*<svg className= {this.props.actif ? "actif": "disable"} height={this.props.height? this.props.height :"18"} viewBox="0 0 512.007 512.007" onClick={this.props.onClick}>
          <g>
            <path d="m511.927 126.537c-.279-2.828-1.38-5.666-3.315-8.027-.747-.913 6.893 6.786-114.006-114.113-2.882-2.882-6.794-4.395-10.612-4.394-9.096 0-329.933 0-338.995 0-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45 .001-364.186.041-339.316-.072-340.466zm-166.927-96.534v98c0 8.271-6.729 15-15 15h-19v-113zm-64 0v113h-139c-8.271 0-15-6.729-15-15v-98zm64 291h-218v-19c0-8.271 6.729-15 15-15h188c8.271 0 15 6.729 15 15zm-218 161v-131h218v131zm355-15c0 8.271-6.729 15-15 15h-92c0-19.555 0-157.708 0-180 0-24.813-20.187-45-45-45h-188c-24.813 0-45 20.187-45 45v180h-52c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h52v98c0 24.813 20.187 45 45 45h188c24.813 0 45-20.187 45-45v-98h2.787l104.213 104.214z"/>
          </g>
        </svg>
        */
  }
}

export default DiscardCommand;
